// --- Dependencies -------------------------------------------------------------------------------
import type { ReactNode } from "react";
// --- Our Modules --------------------------------------------------------------------------------
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = {
    /** Who or what this screen is about — a record's identity, or the drive's path and its usage. */
    head: ReactNode;
    /** The actions bar. It is the panel's last band rather than a separate card below it. */
    children?: ReactNode;
};

/**
 * The card at the top of a section: a head, and the bar of tabs and actions beneath it, inside one
 * border.
 *
 * Two cards stacked read as two things, and the bar is not a thing — it acts on whatever the head
 * names. So the head and the bar share a frame, and the bar gives up its own.
 *
 * It holds the frame and nothing else. What the head contains is the screen's business, which is why
 * `RecordPanel` and the drive can both sit on this without one of them bending to fit the other.
 */
export default function HeaderPanel({ head, children }: Props) {
    return (
        <section className="header-panel">
            {head}
            {children && <div className="header-panel__bar">{children}</div>}
        </section>
    );
}
